﻿/* Surti Flavour — finalized product-card design (shared).
   Transforms every .bs-card into the alt layout used on the homepage,
   preserving the hooks that sort/filter/search/cart/product-links rely on:
   .bs-card__name, .bs-card__price .now/.was, data-cat, .bs-card__add[data-add].
   Also injects the mobile "3 options" pack-picker bottom sheet. */
(function(){
  if(window.__sfCards) return; window.__sfCards=1;

  /* ---------- 1. CSS (class-based, page-agnostic) ---------- */
  var css=''
  +'.bs-card--alt .bs-card__body{gap:.36rem;text-align:left;padding:14px 14px 14px;display:flex;flex-direction:column;flex:1}'
  +'.bs-card--alt .bs-card__name{margin:0;font-family:"Plus Jakarta Sans",sans-serif;font-weight:800;font-size:1.2rem;line-height:1.2;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}'
  +'.sfa-metarow{display:flex;align-items:center;gap:.5rem;flex-wrap:nowrap;margin:0}'
  +'.bs-card--alt .sfa-wt{background:none;padding:0;font-size:.8rem;color:#a3a3a3;font-weight:600;white-space:nowrap}'
  +'.sfa-rating{display:flex;align-items:center;gap:.35rem;font-size:.82rem;color:#6b6b6b;white-space:nowrap}'
  +'.sfa-rating .sfa-stars{color:#f5b301;letter-spacing:.5px;font-size:.82rem}'
  +'.bs-card--alt .bs-card__price{display:flex;align-items:baseline;gap:.5rem;margin:0;flex-wrap:wrap}'
  +'.bs-card--alt .bs-card__price .now{font-family:"Plus Jakarta Sans",sans-serif;font-weight:800;font-size:1.25rem;color:#0a0a0a;line-height:1}'
  +'.bs-card--alt .bs-card__price .was{font-size:.95rem;color:#9a9a9a;text-decoration:line-through}'
  +'.bs-card--alt .bs-card__save{background:#0a0a0a;color:#fff;font-weight:700;font-size:.68rem;padding:.16rem .46rem;border-radius:12px}'
  +'.bs-card--alt .bs-card__add{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center;width:100%!important;gap:.03rem!important;line-height:1.14;background:#1eb473;color:#fff;border:none;border-radius:12px;padding:.9rem!important;font-family:"Plus Jakarta Sans",sans-serif;font-weight:800;font-size:.85rem!important;letter-spacing:.6px;text-transform:uppercase;box-shadow:none;margin-top:.4rem;cursor:pointer;transition:background .15s;flex-shrink:1!important}'
  +'.bs-card--alt .bs-card__add:hover{background:#189d63;transform:none}'
  +'.bs-card--alt .bs-card__add svg{display:none!important}'
  +'.sfa-opts{display:none;font-weight:600;font-size:.62rem;opacity:.9;letter-spacing:.3px;text-transform:none}'
  +'.sfa-packs{display:flex;gap:.45rem;flex-wrap:wrap;justify-content:flex-start;margin:.15rem 0 0}'
  +'.sfa-pack{flex:0 0 auto;border:1.5px solid rgba(10,10,10,.18);background:#fff;color:#0a0a0a;font-family:"Plus Jakarta Sans",sans-serif;font-weight:700;font-size:.76rem;padding:.5rem .8rem;border-radius:12px;cursor:pointer;white-space:nowrap;transition:background .15s,color .15s,border-color .15s}'
  +'.sfa-pack.is-active{background:#e2dfd8;color:#0a0a0a;border-color:transparent}'
  +'.sfa-pack .sfa-px{display:none}'
  +'@media(max-width:600px){.sfa-metarow{flex-wrap:nowrap!important;gap:.3rem}.sfa-metarow .sfa-rw{display:none}.sfa-rating{font-size:.6rem;gap:.2rem;white-space:nowrap}.sfa-rating .sfa-stars{font-size:.68rem;letter-spacing:0}.bs-card--alt .sfa-wt{font-size:.6rem;white-space:nowrap}.bs-card--alt .bs-card__price .now{font-size:1.12rem}.bs-card--alt .bs-card__name{font-size:1.02rem}.bs-card--alt .bs-card__add{padding:.55rem!important;font-size:.8rem!important}.sfa-packs{display:none}.sfa-opts{display:block}}'
  /* sheet */
  +'.sfsheet-ov{position:fixed;inset:0;background:rgba(0,0,0,.5);opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s;z-index:60}'
  +'.sfsheet-ov.open{opacity:1;visibility:visible}'
  +'.sfsheet{position:fixed;left:0;right:0;bottom:0;z-index:61;background:#fff;border-radius:12px 12px 0 0;padding:18px 16px calc(20px + env(safe-area-inset-bottom));transform:translateY(102%);transition:transform .3s cubic-bezier(.2,.7,.2,1);max-height:82vh;overflow-y:auto;box-shadow:0 -10px 40px -12px rgba(0,0,0,.3)}'
  +'.sfsheet.open{transform:translateY(0)}'
  +'.sfsheet__h{display:flex;align-items:flex-start;justify-content:space-between;gap:1rem;margin-bottom:14px}'
  +'.sfsheet__h h3{font-family:"Plus Jakarta Sans",sans-serif;font-weight:800;font-size:1.02rem;margin:0;line-height:1.3;color:#0a0a0a}'
  +'.sfsheet__x{background:#f0efec;border:none;width:32px;height:32px;border-radius:50%;font-size:1.15rem;line-height:1;cursor:pointer;color:#333;flex-shrink:0}'
  +'.sfsheet__g{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:4px}'
  +'.sfsheet__g::-webkit-scrollbar{display:none}'
  +'.sfopt{flex:0 0 clamp(148px,42vw,168px);scroll-snap-align:start;border:1.5px solid rgba(10,10,10,.12);border-radius:12px;padding:11px 10px;display:flex;flex-direction:column;gap:.22rem;background:#fff}'
  +'.sfopt__m{position:relative;width:100%;aspect-ratio:1;background:#f4f3ef;border-radius:12px;margin-bottom:1.15rem}'
  +'.sfopt__m img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:12px}'
  +'.sfopt__off{position:absolute;top:6px;left:6px;z-index:2;background:#e5484d;color:#fff;font-weight:800;font-size:.6rem;padding:.18rem .42rem;border-radius:12px;letter-spacing:.2px}'
  +'.sfopt__add{position:absolute;right:8px;bottom:-14px;z-index:2;background:#fff;color:#1eb473;border:1.6px solid #1eb473;border-radius:12px;padding:.42rem .95rem;font-family:"Plus Jakarta Sans",sans-serif;font-weight:800;font-size:.72rem;letter-spacing:.4px;text-transform:uppercase;cursor:pointer;box-shadow:0 4px 10px -4px rgba(0,0,0,.22);transition:background .15s,color .15s}'
  +'.sfopt__add:hover{background:#1eb473;color:#fff}'
  +'.sfopt__n{font-family:"Plus Jakarta Sans",sans-serif;font-weight:800;font-size:.86rem;color:#0a0a0a}'
  +'.sfopt__wt{font-size:.72rem;color:#9a9a9a}'
  +'.sfopt__p{display:flex;align-items:baseline;gap:.35rem;margin-top:.05rem}'
  +'.sfopt__p .n{font-weight:800;font-size:1.02rem;color:#0a0a0a}'
  +'.sfopt__p .w{font-size:.75rem;color:#9a9a9a;text-decoration:line-through}'
  +'.sfopt__per{font-size:.66rem;color:#9a9a9a}'
  +'@media(min-width:601px){.sfsheet,.sfsheet-ov{display:none!important}}';
  var st=document.createElement('style'); st.textContent=css; (document.head||document.documentElement).appendChild(st);

  /* ---------- 2. sheet DOM ---------- */
  function ensureSheet(){
    if(document.getElementById('sfsheet')) return;
    var ov=document.createElement('div'); ov.className='sfsheet-ov'; ov.id='sfsheetOv';
    var sh=document.createElement('div'); sh.className='sfsheet'; sh.id='sfsheet'; sh.setAttribute('role','dialog'); sh.setAttribute('aria-hidden','true');
    sh.innerHTML='<div class="sfsheet__h"><h3 id="sfsheetT">Choose a pack</h3><button class="sfsheet__x" id="sfsheetX" aria-label="Close">×</button></div><div class="sfsheet__g" id="sfsheetG"></div>';
    document.body.appendChild(ov); document.body.appendChild(sh);
    document.getElementById('sfsheetX').addEventListener('click',closeSheet);
    ov.addEventListener('click',closeSheet);
    document.getElementById('sfsheetG').addEventListener('click',function(e){
      var b=e.target.closest('.sfopt__add'); if(!b) return;
      var pn=b.getAttribute('data-pn'), pp=b.getAttribute('data-pp'), pi=b.getAttribute('data-pi');
      if(typeof window.add==='function'){
        window.add(pn,pp,pi,'Ready-to-eat');
      } else {
        /* fall back to the page's delegated [data-add] cart handler */
        var tmp=document.createElement('button');
        tmp.setAttribute('data-add',pn); tmp.setAttribute('data-price',pp);
        tmp.style.display='none'; document.body.appendChild(tmp);
        tmp.click(); document.body.removeChild(tmp);
      }
      closeSheet(); if(typeof window.openCart==='function') window.openCart();
    });
  }
  function openSheet(cta){
    ensureSheet();
    var card=cta.closest('.bs-card');
    var name=cta.getAttribute('data-add')||'', base=Number(cta.getAttribute('data-price'))||0;
    var imgEl=card?card.querySelector('.bs-card__media img'):null; var img=imgEl?imgEl.getAttribute('src'):'';
    var wtEl=card?card.querySelector('.sfa-wt'):null; var wt=wtEl?wtEl.textContent.replace(/net\s*wt\.?\s*/i,'').trim():'';
    document.getElementById('sfsheetT').textContent=name+' — choose a pack';
    var packs=[{q:1,d:0},{q:3,d:.08},{q:5,d:.12}];
    document.getElementById('sfsheetG').innerHTML=packs.map(function(p){
      var was=base*p.q, now=Math.round(was*(1-p.d)), per=Math.round(now/p.q);
      return '<div class="sfopt"><div class="sfopt__m">'+
        (p.d?'<span class="sfopt__off">'+Math.round(p.d*100)+'% OFF</span>':'')+
        (img?'<img src="'+img+'" alt="">':'')+
        '<button class="sfopt__add" data-pn="'+name+' (Pack of '+p.q+')" data-pp="'+now+'" data-pi="'+img+'">ADD</button></div>'+
        '<div class="sfopt__n">Pack of '+p.q+'</div>'+
        (wt?'<div class="sfopt__wt">'+wt+(p.q>1?' × '+p.q:'')+'</div>':'')+
        '<div class="sfopt__p"><span class="n">₹'+now+'</span>'+(p.d?'<span class="w">₹'+was+'</span>':'')+'</div>'+
        '<div class="sfopt__per">₹'+per+'/pack</div></div>';
    }).join('');
    document.getElementById('sfsheet').classList.add('open');
    document.getElementById('sfsheetOv').classList.add('open');
    document.getElementById('sfsheet').setAttribute('aria-hidden','false');
  }
  function closeSheet(){var s=document.getElementById('sfsheet'),o=document.getElementById('sfsheetOv'); if(s)s.classList.remove('open'); if(o)o.classList.remove('open'); if(s)s.setAttribute('aria-hidden','true');}

  /* ---------- 3. transform a card body to alt ---------- */
  function txt(el){return el?el.textContent.trim():'';}
  function transform(card){
    if(!card || card.classList.contains('bs-card--alt')) return;
    var body=card.querySelector('.bs-card__body'); if(!body) return;
    var name=txt(card.querySelector('.bs-card__name'));
    if(!name) return;
    var rc=(txt(card.querySelector('.bs-card__rating span:last-child')).replace(/[^0-9]/g,''))||'';
    var mimg=card.querySelector('.bs-card__media img');
    var isCombo=mimg && /(^|\/)combo\//.test(mimg.getAttribute('src')||'');
    var wtRaw=txt(card.querySelector('.bs-card__meta-i')).replace(/net\s*wt\.?\s*/i,'').trim();
    var priceEl=card.querySelector('.bs-card__price');
    var nowT=txt(card.querySelector('.bs-card__price .now')).replace(/[^0-9]/g,'');
    var wasT=txt(card.querySelector('.bs-card__price .was')).replace(/[^0-9]/g,'');
    var addBtn=card.querySelector('.bs-card__add');
    var addName=addBtn?(addBtn.getAttribute('data-add')||name):name;
    var addPrice=addBtn?(addBtn.getAttribute('data-price')||nowT):nowT;
    var stars='★★★★★';
    var metarow='<div class="sfa-metarow">'
      +((wtRaw&&!isCombo)?'<span class="sfa-wt">Net Wt. '+wtRaw+'</span>':'')
      +'<div class="sfa-rating"><span class="sfa-stars">'+stars+'</span>'+(rc?'<span><span class="sfa-rn">'+rc+'</span> <span class="sfa-rw">reviews</span></span>':'')+'</div></div>';
    var priceHtml='<div class="bs-card__price">'
      +'<span class="now">Rs. '+nowT+'</span>'
      +(wasT?'<span class="was">Rs. '+wasT+'</span>':'')
      +'</div>';
    var packs='<div class="sfa-packs">'
      +'<button type="button" class="sfa-pack is-active"><span class="sfa-pw">Pack Of </span><span class="sfa-px">×</span>1</button>'
      +'<button type="button" class="sfa-pack"><span class="sfa-pw">Pack Of </span><span class="sfa-px">×</span>3</button>'
      +'<button type="button" class="sfa-pack"><span class="sfa-pw">Pack Of </span><span class="sfa-px">×</span>5</button></div>';
    body.innerHTML='<h3 class="bs-card__name">'+name+'</h3>'
      +metarow+priceHtml+packs
      +'<button class="bs-card__add" data-add="'+addName.replace(/"/g,'&quot;')+'" data-price="'+addPrice+'">ADD TO CART<span class="sfa-opts">3 options</span></button>';
    card.classList.add('bs-card--alt');
    if(isCombo) card.classList.add('bs-card--combo');
  }
  function runAll(root){ (root||document).querySelectorAll('.bs-card').forEach(transform); }

  /* ---------- 4a. desktop pack toggle ---------- */
  document.addEventListener('click',function(e){
    var b=e.target.closest('.sfa-pack'); if(!b) return;
    var wrap=b.closest('.sfa-packs'); if(!wrap) return;
    wrap.querySelectorAll('.sfa-pack').forEach(function(x){x.classList.remove('is-active');});
    b.classList.add('is-active');
  });

  /* ---------- 4b. mobile interceptor: open sheet ---------- */
  document.addEventListener('click',function(e){
    if(window.innerWidth>600) return;
    var cta=e.target.closest('.bs-card--alt .bs-card__add');
    if(!cta) return;
    e.preventDefault(); e.stopImmediatePropagation();
    openSheet(cta);
  },true);

  /* ---------- 5. run + observe ---------- */
  function init(){
    runAll();
    try{
      var mo=new MutationObserver(function(muts){
        var hit=false;
        muts.forEach(function(m){[].forEach.call(m.addedNodes||[],function(n){
          if(n.nodeType===1 && ((n.classList&&n.classList.contains('bs-card')) || (n.querySelector&&n.querySelector('.bs-card')))) hit=true;
        });});
        if(hit) runAll();
      });
      mo.observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
